import dayjs from 'dayjs'

export const bookingMixin = {
  props: {
    formResponse: Object,
    submitted: Boolean
  },
  data: function () {
  },
  computed: {
    isAirBnbBooking: function () {
      if (this.formResponse.booking.channel.providerChannelName === 'Airbnb') {
        return true
      }
      return false
    },
    isAmendingBooking: function () {
      if (this.formResponse.booking.state === 'requesting-amendment') {
        return true
      }
      return false
    },
    numberOfNights: function () {
      const arrival = dayjs(this.formResponse.booking.arrival)
      const departure = dayjs(this.formResponse.booking.departure)
      return departure.diff(arrival, 'days')
    },
    initialNumberOfNights: function () {
      const initialArrival = dayjs(this.formResponse.booking.initialArrival)
      const initialDeparture = dayjs(this.formResponse.booking.initialDeparture)
      return initialDeparture.diff(initialArrival, 'days')
    },
    totalPersons: function () {
      let total = 0
      for (const room of this.formResponse.booking.rooms) {
        total += room.numberOfAdults
        total += room.numberOfChildren1
        total += room.numberOfChildren2
      }
      return total
    },
    initialTotalPersons: function () {
      let total = 0
      for (const room of this.formResponse.booking.rooms) {
        total += room.initialNumberOfAdults
        total += room.initialNumberOfChildren1
        total += room.initialNumberOfChildren2
      }
      return total
    },
    breakageDeposit: function () {
      let deposit = 0
      for (const bookedRoom of this.formResponse.booking.rooms) {
        if (bookedRoom.breakageDeposit > deposit) {
          deposit = bookedRoom.breakageDeposit
        }
      }
      return deposit
    },
    showFormButtonText: function () {
      if (this.formResponse.editable) {
        if (!this.formResponse.completed) {
          for (const section of this.formResponse.sections) {
            for (const answer of section.answers) {
              if (answer.answer) {
                return 'Continue ' + this.formResponse.title
              }
            }
          }
          return 'Start ' + this.formResponse.title
        }
      }
      return 'Show your response'
    },
    showShowFormButton: function () {
      if (this.formResponse.completed || !this.submitted) {
        return true
      }
      return false
    }
  },
  methods: {
    isChildrenCategory1Allowed: function (room) {
      if (this.formResponse.establishment.roomTypes) {
        for (const roomType of this.formResponse.establishment.roomTypes) {
          if (room.externalRoomTypeId === roomType.externalId) {
            return roomType.childPolicy.allowChildCategory1
          }
        }
      }
      return true
    },
    isChildrenCategory2Allowed: function (room) {
      if (this.formResponse.establishment.roomTypes) {
        for (const roomType of this.formResponse.establishment.roomTypes) {
          if (room.externalRoomTypeId === roomType.externalId) {
            return roomType.childPolicy.allowChildCategory2
          }
        }
      }
      return true
    },
    getAllChildrenForRoom: function (room) {
      const allChildren = []
      allChildren.concat(room.children1)
      allChildren.concat(room.children2)
      return allChildren
    },
    formatDate: function (dateX) {
      return dayjs(dateX).format('D MMMM YYYY')
    },
    getUnitTypeForDisplay: function (displayCategoryForRoomTypes) {
      switch (displayCategoryForRoomTypes) {
        case 'room':
          return 'Room'
        case 'unit':
          return 'Unit'
        case 'property':
          return 'Property'
      }
    },
    getUnitTypeForDisplayPlural: function (displayCategoryForRoomTypes) {
      switch (displayCategoryForRoomTypes) {
        case 'room':
          return 'Rooms'
        case 'unit':
          return 'Units'
        case 'property':
          return 'Properties'
      }
    }
  }
}
